<template>
  <div class="v-stories">
    <sheet>
      <div class="article-wrap">
        <loading v-if="isLoading" />
        <brief-article :articles="articles" v-else/>
      </div>

      <div class="pagination-wrap">
        <pagination :pager="pager" @handlePagination="handlePagination" />
      </div>
    </sheet>
  </div>
</template>
<script>
import {
  defineComponent, ref, reactive, watch,
} from 'vue';
import { useRoute, useRouter } from 'vue-router';
import BriefArticle from '@/components/Global/BriefArticle.vue';
import Pagination from '@/components/Global/Pagination.vue';
import { getViewArticlesAPI } from '@/api/articles';
import useRequest from '@/hooks/useRequest';
import useAsyncDialog from '@/hooks/useAsyncDialog';

export default defineComponent({
  name: 'Stories',
  components: {
    BriefArticle,
    Pagination,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const articles = ref([]);
    const { asyncDialog } = useAsyncDialog();

    const pager = reactive({
      pageIndex: Number(route.query?.pageIndex) || 1,
      totalPage: 7,
    });

    const { response, request, isLoading } = useRequest(getViewArticlesAPI);
    request({ ...pager, type: 'cherishStory' });

    const getViewArticles = (res) => {
      // 若沒有相對應可以解構的 key，會 stock，所以只解構第一層
      const {
        result, status, message,
      } = res.value;

      if (status) {
        articles.value = result.data;
        pager.totalPage = result.pageCount;

        return;
      }

      asyncDialog({
        desc: message,
      });

      articles.value = [];
    };

    const handlePagination = (targetPage) => {
      pager.pageIndex = targetPage;

      router.push({
        name: 'stories',
        query: {
          pageIndex: pager.pageIndex,
        },
      });
      request({ ...pager, type: 'cherishStory' });
    };

    watch(response, () => {
      getViewArticles(response);
    });

    return {
      // activeTabKey,
      // tabsConfig,
      // articlesMock,
      pager,
      articles,
      handlePagination,
      isLoading,
    };
  },
});
</script>
<style lang="scss" scoped>
.media-wrap {
  margin-top: 70px;
}
</style>
